// Simple array of cuisine types
export const CUISINE_TYPES = [
  'North Indian',
  'South Indian',
  'Biryani',
  'Fast Food',
  'Chinese / Indo-Chinese',
  'Snacks',
  'Meals / Thali',
  'Desserts',
  'Beverages',
  'Italian',
  'Mexican',
  'Continental',
  'American',
  'Mediterranean',
  'Middle Eastern',
  'Lebanese',
  'Turkish',
  'Thai',
  'Asian',
  'Pan-Asian'
]

// Dropdown-friendly format with label and value
export const CUISINE_DROPDOWN_OPTIONS = CUISINE_TYPES.map((cuisine) => ({
  label: cuisine,
  value: cuisine
}))

export type CuisineType = (typeof CUISINE_TYPES)[number]
